import React from 'react';
import Glider from 'react-glider';
import 'glider-js/glider.min.css';

import {
  SliderContainerCustom,
  SliderButton,
} from './styles';

const SliderContainer = ({ children, ...other }) => (
  <SliderContainerCustom {...other}>
    {children}
  </SliderContainerCustom>
);
const SliderPrevious = ({ children, ...other }) => (
  <SliderButton id="gliderprev" anchor="left" role="button" aria-label="Previous" {...other}>
    {children}
  </SliderButton>
);

const SliderNext = ({ children, ...other }) => (
  <SliderButton id="glidernext" anchor="right" role="button" aria-label="Next" {...other}>
    {children}
  </SliderButton>
);

const SliderDots = ({ children, ...other }) => (
  <div role="tablist" id="dots" {...other}>
    {children}
  </div>
);

function Slider({
  children,
  draggable,
  dragVelocity,
  propagateEvent,
  scrollLock,
  scrollLockDelay,
  scrollPropagate,
  hasArrows,
  hasDots,
  scrollToSlide,
  scrollToPage,
  slidesToShow,
  slidesToScroll,
  itemWidth,
  duration,
  componentPrevious,
  componentNext,
  responsive,
  ...other
}) {
  const gliderRef = React.useRef();
  return (
    <Glider
      ref={gliderRef}
      dots="#dots"
      arrows={{
        prev: '#gliderprev',
        next: '#glidernext',
      }}
      draggable={draggable}
      dragVelocity={dragVelocity}
      propagateEvent={propagateEvent}
      scrollLock={scrollLock}
      scrollLockDelay={scrollLockDelay}
      scrollPropagate={scrollPropagate}
      hasArrows={hasArrows}
      hasDots={hasDots}
      scrollToSlide={scrollToSlide}
      scrollToPage={scrollToPage}
      slidesToShow={slidesToShow}
      slidesToScroll={slidesToScroll}
      itemWidth={itemWidth}
      duration={duration}
      responsive={responsive}
      skipTrack
      {...other}
    >
      <div className="glider-track">
        {children}
      </div>
    </Glider>
  );
}

export {
  SliderContainer,
  Slider,
  SliderPrevious,
  SliderNext,
  SliderDots,
};
